// @flow

import {
  CLEAR_MENTOR_DASHBOARD_HISTORY,
  FETCH_DASHBOARD_HISTORY_FAILURE,
  FETCH_DASHBOARD_HISTORY_REQUEST,
  FETCH_DASHBOARD_HISTORY_SUCCESS,
  FETCH_MENTOR_NOTIFICATIONS_FAILURE,
  FETCH_MENTOR_NOTIFICATIONS_REQUEST,
  FETCH_MENTOR_NOTIFICATIONS_SUCCESS,
  REMOVE_NOTIFICATION,
  SET_SORT,
  SET_LEARNER_FILTER,
  SET_QUEST_FILTER,
  SET_MD_COURSE_FILTER,
  SET_SEARCH_TEXT,
  NEEDS_REFRESH,
  SET_TOTAL_NOTIFICATIONS_COUNT
} from '../actions/mentordashboard'

const initialState: {
  nextHistoryUrl: ?string,
  history: ?Array<Object>,
  historyDone: boolean,
  notifications: ?Array<Object>,
  isFetchingHistory: boolean,
  isFetchingNotifications: boolean,
  sortField: string,
  sortDirection: string,
  courseSectionId: number,
  learnerId: ?number,
  questId: ?number,
  searchText: string,
  needsRefresh: boolean,
  totalNotificationsCount: number
} = {
  nextHistoryUrl: null,
  history: [],
  historyDone: false,
  notifications: [],
  isFetchingHistory: false,
  isFetchingNotifications: false,
  sortField: 'time',
  sortDirection: 'asc',
  courseSectionId: -1,
  learnerId: null,
  questId: null,
  searchText: '',
  needsRefresh: false,
  totalNotificationsCount: 0
}

export function mentordashboard(
  state: Object = initialState,
  action: Object
): Object {
  switch (action.type) {
    case SET_TOTAL_NOTIFICATIONS_COUNT: {
      return Object.assign({}, state, {
        totalNotificationsCount: action.count
      })
    }

    case CLEAR_MENTOR_DASHBOARD_HISTORY: {
      return Object.assign({}, state, {
        history: [],
        nextHistoryUrl: null,
        isFetchingHistory: false,
        courseSectionId: -1,
        learnerId: null,
        questId: null,
        searchText: ''
      })
    }

    case NEEDS_REFRESH: {
      return Object.assign({}, state, {
        needsRefresh: action.refresh
      })
    }

    case FETCH_DASHBOARD_HISTORY_REQUEST: {
      return Object.assign({}, state, {
        isFetchingHistory: true
      })
    }

    case FETCH_DASHBOARD_HISTORY_SUCCESS: {
      let history = Object.assign([], state.history)

      action.history.forEach(item => {
        history.push(item)
      })

      return Object.assign({}, state, {
        history: history,
        nextHistoryUrl: action.nextHistoryUrl,
        historyDone: action.historyDone,
        isFetchingHistory: false
      })
    }

    case FETCH_DASHBOARD_HISTORY_FAILURE: {
      return Object.assign({}, state, {
        history: [],
        nextHistoryUrl: null,
        isFetchingHistory: false
      })
    }

    case FETCH_MENTOR_NOTIFICATIONS_REQUEST: {
      return Object.assign({}, state, {
        notifications: [],
        isFetchingNotifications: true
      })
    }

    case FETCH_MENTOR_NOTIFICATIONS_SUCCESS: {
      return Object.assign({}, state, {
        notifications: action.notifications,
        totalNotificationsCount: action.notifications.length,
        isFetchingNotifications: false
      })
    }

    case FETCH_MENTOR_NOTIFICATIONS_FAILURE: {
      return Object.assign({}, state, {
        notifications: [],
        isFetchingNotifications: false
      })
    }

    case REMOVE_NOTIFICATION: {
      const allNotifications = state.notifications.splice(0)
      const notification = allNotifications.find(
        n => n.id === action.notificationId
      )
      const filtered = allNotifications.filter(
        n => n.id !== action.notificationId
      )
      const filteredState = Object.assign({}, state, {
        notifications: filtered,
        totalNotificationsCount: filtered.length
      })
      const unfilteredState = Object.assign({}, state, {
        notifications: allNotifications,
        totalNotificationsCount: allNotifications.length
      })

      if (!notification) {
        return unfilteredState
      }

      // ugh
      if (
        Object.keys(notification.additional_resolution_criteria).length === 0
      ) {
        return filteredState
      } else if (action.rejection) {
        return filteredState
      } else {
        if (
          notification.additional_resolution_criteria
            .artifact_assessment_completed_at ||
          notification.additional_resolution_criteria.checkin_approved_at
        ) {
          return filteredState
        } else {
          return unfilteredState
        }
      }
    }

    case SET_SORT: {
      return Object.assign({}, state, {
        sortField: action.field,
        sortDirection: action.direction
      })
    }

    case SET_LEARNER_FILTER: {
      return Object.assign({}, state, {
        learnerId: action.learnerId,
        questId: null
      })
    }

    case SET_QUEST_FILTER: {
      return Object.assign({}, state, {
        questId: action.questId,
        learnerId: null
      })
    }

    case SET_MD_COURSE_FILTER: {
      return Object.assign({}, state, {
        courseSectionId: action.courseSectionId
      })
    }

    case SET_SEARCH_TEXT: {
      return Object.assign({}, state, {
        searchText: action.searchText
      })
    }

    default:
      return state
  }
}
